import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  DEFAULT_KIOSK_TIMEOUT_MS,
  DEFAULT_QR_EXPIRY_MS,
  DEFAULT_LOGOUT_SESSION_MS,
  fetchKioskTimeoutSettings,
} from "../../services/kioskTimeoutService";

export type KioskState = {
  milliseconds: number;
  qrExpiryMs: number;
  logoutSessionMs: number;
  loaded: boolean;
  loading: boolean;
};

const initialState: KioskState = {
  milliseconds: DEFAULT_KIOSK_TIMEOUT_MS,
  qrExpiryMs: DEFAULT_QR_EXPIRY_MS,
  logoutSessionMs: DEFAULT_LOGOUT_SESSION_MS,
  loaded: false,
  loading: false,
};

export const loadKioskTimeout = createAsyncThunk(
  "kiosk/loadKioskTimeout",
  async () => fetchKioskTimeoutSettings()
);

const kioskSlice = createSlice({
  name: "kiosk",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadKioskTimeout.pending, (state) => {
        state.loading = true;
      })
      .addCase(loadKioskTimeout.fulfilled, (state, action) => {
        state.milliseconds =
          action.payload.milliseconds > 0
            ? action.payload.milliseconds
            : DEFAULT_KIOSK_TIMEOUT_MS;
        state.qrExpiryMs =
          action.payload.qrExpiryMs > 0
            ? action.payload.qrExpiryMs
            : DEFAULT_QR_EXPIRY_MS;
        state.logoutSessionMs =
          action.payload.logoutSessionMs > 0
            ? action.payload.logoutSessionMs
            : DEFAULT_LOGOUT_SESSION_MS;
        state.loaded = true;
        state.loading = false;
      })
      .addCase(loadKioskTimeout.rejected, (state) => {
        state.milliseconds = DEFAULT_KIOSK_TIMEOUT_MS;
        state.qrExpiryMs = DEFAULT_QR_EXPIRY_MS;
        state.logoutSessionMs = DEFAULT_LOGOUT_SESSION_MS;
        state.loaded = true;
        state.loading = false;
      });
  },
});

export default kioskSlice.reducer;
